// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"305644b7","324":"7dae6088","388":"914fe176","682":"5b319dc3","828":"4ec4f00f"}[chunkId] + ".chunk.css";
};